<template>
  <div class="container" v-html="policy">
  </div>
</template>

<script>
  var axios = require('axios');
  var CONFIG = require('@/common/config.js');
  var base_url = CONFIG.API_URL.BASE_URL;
  export default {
    name: 'policy',
    data () {
      return {
        policy: ''
      }
    },
    created () {
      this.getpage()
    },
    methods: {
      //获取配置信息
      getpage:function(){
        var that = this;
        axios.post(base_url+'front/getPageList').then(function (res) {
          console.log(res);
          if(res.data.code == 0){
            var dataList = res.data.result;
            for(var i=0;i<dataList.length;i++){
              if(dataList[i]['title'] == '辰图网站用户协议'){
                that.policy = dataList[i]['content'];
              }
            }
          }
        }).catch(function (err) {
          //console.log(err);
        })
      },
    }
  }
</script>

<style scoped>
.container{
  width: 1200px;
  margin: 0 auto;
}
@media only screen and (max-width: 559px) {
  .container{
    width: 375px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/inner/policy.vue